import { useEffect, useRef } from "react";

// Plays only the [start, end] segment of a video (lightweight trim, no re-encode).
export default function TrimmedVideo({ src, start, end, className = "", controls = true, testid }) {
  const ref = useRef(null);
  const s = typeof start === "number" ? start : null;
  const e = typeof end === "number" ? end : null;

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const onMeta = () => { if (s != null && v.currentTime < s) v.currentTime = s; };
    const onTime = () => {
      if (s != null && v.currentTime < s - 0.2) v.currentTime = s;
      if (e != null && v.currentTime >= e) { v.pause(); v.currentTime = s != null ? s : 0; }
    };
    const onPlay = () => { if (s != null && (v.currentTime < s || (e != null && v.currentTime >= e))) v.currentTime = s; };
    v.addEventListener("loadedmetadata", onMeta);
    v.addEventListener("timeupdate", onTime);
    v.addEventListener("play", onPlay);
    return () => {
      v.removeEventListener("loadedmetadata", onMeta);
      v.removeEventListener("timeupdate", onTime);
      v.removeEventListener("play", onPlay);
    };
  }, [s, e, src]);

  return <video ref={ref} src={src} controls={controls} playsInline className={className} data-testid={testid} />;
}
